export default __webpack_public_path__ + "static/media/figure-area-3.dd4bb9fc.svg";